'use client'

import { create } from 'zustand'
import analytics, { Analytics } from '~/lib/client/analytics'

const useAnalytics = create<Analytics>(() => {
  return analytics
})

export { useAnalytics }
